import React from "react"
import {Link} from "react-router-dom"
import {List, ListItem} from "material-ui/List"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import * as Util from "../common"
import {containers} from "@swarm2/core"

const M = Util.intlMessages("view.Rankings")
const RM = Util.intlMessages("rankings")

function RankingsItemRender(props) {
  if (props.isError) return <Util.Error inline error={props} />
  const {charId, displayName, rank, value, displayValue} = props
  return (
    <ListItem
      containerElement={<Link to={"/c/" + charId} />}
      primaryText={rank + ") " + displayName}
      secondaryText={
        <span style={{color: "inherit"}}>
          <Util.Num val={displayValue != null ? displayValue : value} />
        </span>
      }
    />
  )
}
export const RankingsItem = containers.rankings.RankingsItem(RankingsItemRender)

function RankingsBody(props) {
  const {list} = props
  return (
    <List>
      {list.map((ranking, index) => (
        <RankingsItem key={ranking.charId} rank={index + 1} {...ranking} />
      ))}
    </List>
  )
}
function RankingsRender(props) {
  // Don't quit here if pending - show the title bar while loading, cuz it's pretty.
  if (props.isEmpty) return <Util.Error error={props} />
  const {rankName} = props
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle
            text={<M id="title" values={{rankName: <RM id={rankName} />}} />}
          />
        </ToolbarGroup>
      </Toolbar>
      {props.isError ? (
        <Util.Error error={props} />
      ) : (
        <RankingsBody {...props} />
      )}
    </div>
  )
}
export default containers.rankings.Rankings(Util.DumpProps(RankingsRender))



// WEBPACK FOOTER //
// ./src/rankings/Rankings.js